import {templateModelReducer} from '../../../../templates/helpers/template-model-reducer';
import templatePreviewLoader from '../../../../templates/helpers/template-preview-loader';

export default class AddTemplateModalController {
    constructor($uibModalInstance, $scope, $injector, guestlist, statusToLink, fullStates, currentTemplates) {
        this.uibModalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.acl = this.injector.get('Acl');
        this.usersStore = this.injector.get('Users');

        this.guestlist = guestlist;
        this.fullStates = fullStates;
        this.currentTemplates = currentTemplates;

        this.shareInsteadOfCopy = false;
        this.currentAddType = 'existing';

        this.templatePreviewImageUrl = '/images/landingpage.png';
        this.currentSelectedTemplate = null;

        this.templateSelectizeOptions = {
            maxItems: 1,
            valueField: 'id',
            searchField: 'name',
            sortField: 'sort',
            render: {
                option: function (data, escape) {
                    let out = '<div class="option">';

                    if (data.global_template) {
                        out += '<i class="fal fa-link"></i>&nbsp;'
                    }

                    out += escape(data.name) + '</div>';

                    return out;
                },
                item: function (data, escape) {
                    let out = '<div class="item">';

                    if (data.global_template) {
                        out += '<i class="fal fa-link"></i>&nbsp;'
                    }

                    out += escape(data.name) + '</div>';

                    return out;
                }
            }
        }
        this.templatesForSelectize = [];

        this.model = {
            status: statusToLink,
            template_id: null
        };

        this.newTemplateModel = {
            name: this.guestlist.name + ' ' + (this.model.status ? 'Template for ' + this.fullStates[this.model.status] + ' guests' : 'General template'),
            subject: this.model.status ? 'Template for ' + this.fullStates[this.model.status] + ' guests' : 'General template',
            sender_name: _.get(this.usersStore.state, 'company.settings.templates.default_mail_sender_name'),
            email: _.get(this.usersStore.state, 'company.settings.templates.default_mail_sender_address'),
            global_template: false
        };

        this.validForSubmit = false;
        this.submitting = false;
        this._loadTemplatesForSelection();
    }

    $onInit() {
        this._initWatchers();
    }

    linkTemplate() {
        this.submitting = true;
        if (this.currentAddType === 'existing' && this.currentSelectedTemplate.usableAsShared && this.shareInsteadOfCopy) {
            this.api.get(`templates/${this.model.template_id}`).then((response) => {
                const existingTemplate = response.data.data;
                this._linkTemplateToGuestlist(existingTemplate)
            });

            return;
        }

        if (this.currentAddType === 'existing') {
            this.api.get(`templates/${this.model.template_id}`).then((response) => {
                const existingTemplate = response.data.data;

                this.api.post('templates', {
                    ...templateModelReducer(existingTemplate)
                }).then((response) => {
                    this._linkTemplateToGuestlist(response.data.data)
                })
            })
            return;
        }

        if (this.currentAddType === 'new') {
            this.api.post('templates/default-content', this.newTemplateModel).then((response) => {
                this._linkTemplateToGuestlist(response.data.data)
            })
        }
    }

    handleTemplateSelection() {
        this.currentSelectedTemplate = _.first(_.filter(this.templatesForSelectize, (row) => {
            return row.id === parseInt(this.model.template_id);
        }));

        this._prepareTemplatePreviewImage();
    }

    _linkTemplateToGuestlist(template) {
        this.api.post(`guestlists/${this.guestlist.id}/templates`, {
            template_id: template.id,
            status: this.model.status
        }).then(({data}) => {
            this.alert.success('Success', 'Template has been linked');
            this.uibModalInstance.close({
                guestlistTemplate: data.data
            });
        }, () => {
            this.alert.error('Error', 'Error while linking template. Please retry')
        })
    }

    dismissModal() {
        this.uibModalInstance.dismiss();
    }

    _checkValidForSubmit() {
        if (this.currentAddType === 'new') {
            return !!this.newTemplateModel.subject && !!this.newTemplateModel.name;
        } else if (this.currentAddType === 'existing' || this.currentAddType === 'shared') {
            return !!this.model.template_id
        }

        return false;
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.currentAddType;
        }, () => {
            this.validForSubmit = this._checkValidForSubmit();
        }, true);

        this.scope.$watch(() => {
            return this.model;
        }, (newVal, oldVal) => {
            this.validForSubmit = this._checkValidForSubmit();
            if (newVal.template_id !== oldVal.template_id) {
                this.handleTemplateSelection();
            }
        }, true);

        this.scope.$watch(() => {
            return this.newTemplateModel;
        }, () => {
            this.validForSubmit = this._checkValidForSubmit();
        }, true)
    }

    _prepareTemplatePreviewImage() {
        if (!this.currentSelectedTemplate) {
            this.templatePreviewImageUrl = '/images/landingpage.png';
            return;
        }

        templatePreviewLoader(this.injector, this.currentSelectedTemplate.id)
            .then((dataUrl) => {
                this.templatePreviewImageUrl = dataUrl;
            })
            .catch(error => {
            });
    }

    _loadTemplatesForSelection() {
        const store = this.injector.get('Templates').reset({
            listview: 'AddTemplateModalTemplatesListView',
            persist: false,
            onlyScoped: false,
            onlyGlobal: false,
            scopedGuestlists: [],
            pagination: {
                perPage: -1
            },
            columns: [
                {
                    key: 'id',
                    type: 'integer',
                    visible: true
                },
                {
                    key: 'name',
                    type: 'string',
                    visible: true
                },
                {
                    key: 'global_template',
                    type: 'boolean',
                    visible: true
                }
            ]
        });

        store.dispatch('getData').then(() => {
            this.templatesForSelectize = _.map(
                store.state.data.sort(
                    (a, b) => {
                        if (a.global_template !== b.global_template) {
                            return !a.global_template ? 1 : -1;
                        }

                        return ('' + a.name).localeCompare(b.name)
                    }
                ),
                (value, key) => {
                    return {
                        ...value,
                        usableAsShared: (value.global_template && _.filter(this.currentTemplates, (template) => (template.template.id === value.id)).length === 0),
                        sort: key
                    }
                }
            );

            this.model.template_id = _.get(_.first(this.templatesForSelectize), 'id', null);
        })
    }
}

AddTemplateModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'guestlist',
    'statusToLink',
    'fullStates',
    'currentTemplates'
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-templates/controllers/add-template-modal-controller.js